<template>
    <section class="section-module developer-dashboard-module">

        <!-- Loading -->
        <loading />

        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <div class="section-wrapper">
            <h1 class="heading-4">Painel de Controlo</h1>
            <p class="color-text-body">Visão geral dos teus espaços</p>
        </div>

        <div class="section-wrapper">
            <h2 class="section-title heading-6 strong-500">
                Indicadores de Desempenho
            </h2>

            <div class="content-wrapper">
                <h3 class="content-title body-1 strong-600">
                    Capacidade do servidor:
                </h3>
                <div class="canva-wrapper">
                    <div class="chart-wrapper">
                        <chart
                            :datachart="moduleData.serverData.chart"
                        />
                    </div>
                </div>
            </div>
            <div class="content-wrapper">
                <h3 class="content-title body-1 strong-600">Estado do site</h3>
                <div class="form-check-wrapper">
                    <div class="form-check">
                        <input
                            class="form-check-input website-status"
                            v-model="websiteStatus"
                            value="0"
                            type="radio"
                            name="websiteStatus"
                            id="website-status_yes"
                            @click="sendData($event)"
                        />
                        <label
                            class="form-check-label"
                            for="website-status_yes"
                        >
                            <span class="button-body">Website online</span>
                        </label>
                    </div>

                    <div class="form-check">
                        <input
                            class="form-check-input website-status"
                            v-model="websiteStatus"
                            value="1"
                            type="radio"
                            name="websiteStatus"
                            id="website-status_no"
                            @click="sendData($event)"
                        />
                        <label class="form-check-label" for="website-status_no">
                            <span class="button-body"
                                >Website em manutenção</span
                            >
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-wrapper">
            <div class="content-wrapper">
                <h3 class="content-title body-1 strong-600">Informações do servidor</h3>
                <div
                    v-for="(value, index) in moduleData.serverData.server"
                    :key="index" 
                    class="d-flex flex-row"
                >      
                    <p>{{ `${index}: ${value}` }}</p>
                </div>
            </div>
        </div>

        <div class="section-wrapper">
            <h2 class="section-title heading-6 strong-500">
                Feedback dos utilizadores
            </h2>

            <template v-if="Object.hasOwn(moduleData.formData, 'checkout') || 
            Object.hasOwn(moduleData.formData, 'feedback') || 
            Object.hasOwn(moduleData.formData, 'feautures')">

                <div class="double-content-wrapper">
                    <div
                        v-if="Object.values(moduleData.formData.checkout).length > 0" 
                        class="content-wrapper"
                    >
                        <h3 class="content-title body-1 strong-600 center-text">
                            Flow de reservas
                        </h3>
                        <p class="caption-md color-text-body center-text">
                            {{ `${moduleData.formData.checkout.total} avaliações` }}
                        </p>
                        <div class="progression-bars">
                            <div class="progression-bar-content-flex">
                                <div 
                                    v-for="(feedback, index) in feedbackSymbols"
                                    :key="index"
                                    class="progression-bar-item-wrapper">
                                    <label class="buttom-body color-text-body">
                                        <span class="emoji" v-html="feedback.route.checkout.symbol"></span>
                                        <span class="text-center">{{ feedback.route.checkout.text.pt }}</span>
                                    </label>

                                    <div class="bar-and-count">
                                        <span class="caption-lg color-text-body">
                                            {{ Object.hasOwn(moduleData.formData.checkout, feedback.value) ? `${moduleData.formData.checkout[`${feedback.value}`]} votos` : "0 votos" }}
                                        </span>

                                        <progress 
                                            :value="Object.hasOwn(moduleData.formData.checkout, feedback.value) ? moduleData.formData.checkout[`${feedback.value}`] : 0" 
                                            :max="moduleData.formData.checkout.total"
                                        ></progress>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="Object.values(moduleData.formData.feedback).length > 0"  
                        class="content-wrapper"
                    >
                        <h3 class="content-title body-1 strong-600 center-text">
                            Experiência geral
                        </h3>
                        <p class="caption-md color-text-body center-text">
                            {{ `${moduleData.formData.feedback.total} avaliações` }}
                        </p>
                        <div class="progression-bars">
                            <div class="progression-bar-content-flex">
                                <div 
                                    v-for="(feedback, index) in feedbackSymbols"
                                    :key="index"
                                    class="progression-bar-item-wrapper">
                                    <label class="buttom-body color-text-body">
                                        <span class="emoji" v-html="feedback.route.pdp.symbol"></span>
                                        <span class="text-center">{{ feedback.route.pdp.text.pt }}</span>
                                    </label>

                                    <div class="bar-and-count">
                                        <span class="caption-lg color-text-body">
                                            {{ Object.hasOwn(moduleData.formData.feedback, feedback.value) ? `${moduleData.formData.feedback[`${feedback.value}`]} votos` : "0 votos" }}
                                        </span>

                                        <progress 
                                            :value="Object.hasOwn(moduleData.formData.feedback, feedback.value) ? moduleData.formData.feedback[`${feedback.value}`] : 0" 
                                            :max="moduleData.formData.feedback.total"
                                        ></progress>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="content-wrapper">
                    <h3 class="content-title body-1 strong-600">Funcionalidades</h3>
                    <div
                        v-if="Object.values(moduleData.formData.feautures).length > 0"  
                        class="funcionality-wrapper"
                    >
                        <div
                            v-for="(value, index) in moduleData.formData.feautures"
                            :key="index" 
                            class="funcionality-item"
                        >
                            <p>{{ value.feature }}</p>
                            <p class="caption-md color-text-body">
                                {{ index === 0 ? `Mais votada com ${value.total} votos` : `${value.total} votos` }}
                            </p>
                        </div>
                    </div>
                </div>

            </template>

            <template v-else>

                <div class="content-wrapper">

                    <p>Sem dados para apresentar</p>

                </div>

            </template>

        </div>

        <div class="section-wrapper">
            <h2 class="section-title heading-6 strong-500">Log de erros</h2>
            <div
                v-if="logContent.length > 0" 
                class="content-wrapper log-wrapper"
            >
                <div class="log-header">
                    <div class="log-selection">
                        <span>{{ currentDate }}</span>
                    </div>
                <!--     <div class="log-tools">
                        <span role="button" class="remove-log"></span>
                        <span role="button" class="download-log"></span>
                        <span role="button" class="full-screen-log"></span>
                    </div> -->
                </div>
                <div class="log-content">
                    <p v-for="(value, index) in logContent" :key="index">
                        {{ value }}
                    </p>
                </div>
            </div>
            <div v-else>
                <p>No log content to show</p>
            </div>
        </div>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>

    </section>
</template>

<script>
import ChartElementDeveloper from "../../elements/ChartElementDeveloper.vue";
import defaultWebsite from "../../../defaultWebsiteScript.js";
import fetchData from "../../../fetchData";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import responseMessage from "./../../../responseMessage.js";

("use strict");

export default {
    name: "HomeAdmin",
    props:{
        moduledata:{
            type: String,
            required: true
        },
        feedbackdataquestion:{
            type: String,
            required: true
        },
        moduleactive:{
            type: String,
            required: true
        },
        csrftolken: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            websiteStatus: 0,
            moduleData: {},
            feedbackSymbols: {},
            activeclass: "d-flex",
            responseTimeOut: 5000,
            logContent: {},
            currentDate: ''
        };
    },
    created(){

        //Decode data
        this.moduleData = JSON.parse(this.moduledata);
        this.feedbackSymbols = JSON.parse(this.feedbackdataquestion);
        this.websiteStatus = this.moduleData.serverData.website_status.active;
        this.logContent = JSON.parse(this.moduleData.logContent);

        //Set Current Date
        let date = new Date();
        this.currentDate = `${date.getFullYear()}-${(date.getMonth() + 1)}-${date.getDate()}`;

    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });

        //Check Website Status
        [...document.querySelectorAll('.website-status')].forEach((val) => {

            if(parseInt(val.value) === parseInt(this.websiteStatus)){

                val.checked = true;

            }

        });

    },
    methods: {
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        sendData(element) {

            //Disabled element
            [...document.querySelectorAll('.website-status')].forEach((value) => value.setAttribute('disabled', true));
    
            //Confirm Remove
            let confirmRemove = confirm("Deseja prosseguir com a ativação ou desativação ?");

            if (!confirmRemove) {

                //Default Value
                this.websiteStatus = this.moduleData.serverData.website_status.active;
                
                //Enabled element
                [...document.querySelectorAll('.website-status')].forEach((val) => {

                    val.removeAttribute('disabled');

                    if(parseInt(val.value) === parseInt(this.websiteStatus)){

                        val.checked = true;

                    }

                });

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                this.moduleactive,
                {
                    active: parseInt(element.target.value)
                },
                this.csrftolken,
                'PATCH'
            );

            //Check Promisse
            response
                .then((value) => {

                    //Enabled element
                    [...document.querySelectorAll('.website-status')].forEach((value) => value.removeAttribute('disabled'));

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                })
                .catch((error) => {
         
                    //Enabled element
                    [...document.querySelectorAll('.website-status')].forEach((value) => value.removeAttribute('disabled'));

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed:{

        computedWebsiteStatus(){

            return this.websiteStatus;

        }

    },
    watch:{

        computedWebsiteStatus(){}

    },
    components: {
        chart: ChartElementDeveloper,
        listMessage: ListMessage,
        loading: Loading,
    },
};
</script>
